import styled from 'styled-components'
import Section from './Section'

export default styled( Section )`
	box-shadow: ${ ( { theme } ) => `0 0 10px 0 ${ theme.colors.shadow }` };
    padding: ${ ( { padding='3rem 5rem' } ) => padding };
`